import { styled } from '@mui/material';

export type StatusPillVariant =
  | 'AVAILABLE'
  | 'ACTIVE'
  | 'ONGOING'
  | 'CONFIRMED'
  | 'COMPLETED'
  | 'BOOKED'
  | 'PARTIALLY_AVAILABLE'
  | 'PENDING'
  | 'DRAFT'
  | 'NA'
  | 'APPROVED'
  | 'REJECTED'
  | 'CANCELLED'
  | 'ORDERED'
  | 'NOT_ORDERED';

export const StyledStatusPill = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'magentaBooked',
})<{ variant: StatusPillVariant; magentaBooked?: boolean }>(({ theme, variant, magentaBooked }) => {
  let background: string;
  const color = '#FEFEFE';

  switch (variant) {
    case 'AVAILABLE':
    case 'APPROVED':
    case 'COMPLETED':
    case 'ORDERED':
      background = theme.palette.green[500];
      break;
    case 'ACTIVE':
    case 'ONGOING':
    case 'CONFIRMED':
      background = theme.palette.blue[500];
      break;
    case 'BOOKED':
      background = magentaBooked ? theme.palette.magenta[500] : theme.palette.purple[500];
      break;
    case 'PARTIALLY_AVAILABLE':
      background = theme.palette.orange[500];
      break;
    case 'PENDING':
    case 'DRAFT':
    case 'NA':
    case 'NOT_ORDERED':
      background = theme.palette.grey[500];
      break;
    case 'REJECTED':
    case 'CANCELLED':
      background = theme.palette.red[500];
      break;
    default:
      background = theme.palette.grey[500];
  }

  return {
    display: 'flex',
    width: 'fit-content',
    padding: '0.25rem 0.75rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.625rem',
    borderRadius: '0.75rem',
    backgroundColor: background,

    '& > p': {
      margin: 0,
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: '130%',
      color,
    },
  };
});
